import { render, staticRenderFns } from "./nr-attachment-edit-h5.vue?vue&type=template&id=28625bc0&scoped=true"
import script from "./nr-attachment-edit-h5.vue?vue&type=script&lang=ts"
export * from "./nr-attachment-edit-h5.vue?vue&type=script&lang=ts"
import style0 from "./nr-attachment-edit-h5.vue?vue&type=style&index=0&id=28625bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28625bc0",
  null
  
)

export default component.exports